import React, { useMemo } from 'react';
import CustomModal from '@/components/CustomModal';
import { MODAL_CONTENT } from '../const';
import styles from '../index.less';

const IncomeModal = ({ visible, onClose, type = 'invite' }) => {
  const modalContent = useMemo(() => MODAL_CONTENT[type], [type]);
  return (
    <CustomModal visible={visible} title={modalContent.title} okCallback={onClose}>
      <div
        className={styles['modal-text']}
        dangerouslySetInnerHTML={{ __html: modalContent.content }}
      ></div>
    </CustomModal>
  );
};
export default IncomeModal;
